export const SET_TRANSLATIONS = 'SET_TRANSLATIONS';

export function setTranslations(t10s) {
	return {
		type: SET_TRANSLATIONS,
		t10s: t10s
	};
}
